import { CarrierLogo } from "@/components/common/CarrierLogo";
import { ContractLink } from "@/components/common/ContractLink";
import { cn } from "@/lib/utils";

interface CarrierContractLabelProps {
  carrier?: string | null;
  contractRef?: string | null;
  namedAccount?: string | null;
  rateCardId?: string | null;
  size?: number;
  bold?: boolean;
  className?: string;
  contractClassName?: string;
}

/**
 * Carrier logo + agent contract token. The contract links through to the
 * assigned rate card (by id, or by `/rate-cards/by-contract/:ref`).
 */
export function CarrierContractLabel({
  carrier,
  contractRef,
  namedAccount,
  rateCardId,
  size = 16,
  bold = false,
  className,
  contractClassName,
}: CarrierContractLabelProps) {
  const hasContract = Boolean(contractRef?.trim());
  if (!carrier && !hasContract) return null;

  return (
    <span
      className={cn(
        "inline-flex min-w-0 max-w-full items-center gap-1.5",
        className,
      )}
    >
      <CarrierLogo carrier={carrier} size={size} bold={bold} />
      {hasContract && (
        <ContractLink
          contractRef={contractRef}
          namedAccount={namedAccount}
          carrier={carrier}
          rateCardId={rateCardId}
          className={cn("min-w-0 truncate font-mono", contractClassName)}
        />
      )}
    </span>
  );
}
